import { toast } from "sonner"

export const INSUFFICIENT_FUNDS_ERROR_CODE = "InsufficientBalance" as const

export interface InsufficientFundsPayload {
  type: "InsufficientBalance"
  message: string
  statusCode: 402
  timestamp: string
  organizationId: string
  requiredAmount: number
  currentBalance: number | null
  feature: string | null
}

export class InsufficientFundsError extends Error {
  readonly type = "InsufficientBalance" as const
  readonly organizationId: string
  readonly requiredAmount: number
  readonly currentBalance: number | null
  readonly feature: string | null

  constructor(payload: InsufficientFundsPayload) {
    super(payload.message)
    this.name = "InsufficientFundsError"
    this.organizationId = payload.organizationId
    this.requiredAmount = payload.requiredAmount
    this.currentBalance = payload.currentBalance
    this.feature = payload.feature
  }
}

export const isInsufficientFundsPayload = (
  data: unknown,
): data is InsufficientFundsPayload => {
  if (!data || typeof data !== "object") return false
  const candidate = data as { type?: unknown; statusCode?: unknown }
  return (
    candidate.type === "InsufficientBalance" && candidate.statusCode === 402
  )
}

const DEFAULT_INSUFFICIENT_FUNDS_MESSAGE =
  "Your wallet balance is too low. Please top up your wallet to continue."

export const showInsufficientFundsToast = (message?: string | null): void => {
  toast.error(message?.trim() || DEFAULT_INSUFFICIENT_FUNDS_MESSAGE, {
    action: {
      label: "Top up wallet",
      onClick: () => {
        window.location.href = "/wallet"
      },
    },
  })
}
